export const PHONE_PREVIEW_CONFIG = {
  originalWidth: 325,
  originalHeight: 630,
  padding: { top: 13, bottom: 13, left: 14, right: 14 },
  borderRadius: 34,
  viewport: { min: 700, max: 800 },
  height: { min: 500, max: 630 },
  verticalChrome: 200,
  selectorVerticalChrome: 290,
} as const;
